"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOpenedByHover = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var MenuPosition_1 = require("../positioning/MenuPosition");
var MenuOpenedByHover = /** @class */ (function (_super) {
    tslib_1.__extends(MenuOpenedByHover, _super);
    function MenuOpenedByHover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timerCloseDelay = null;
        _this.clearCloseDelayTimer = function () {
            if (_this.timerCloseDelay) {
                window.clearTimeout(_this.timerCloseDelay);
            }
        };
        _this.hoverStart = function () {
            _this.clearCloseDelayTimer();
            _this.timerCloseDelay = window.setTimeout(function () {
                _this.props.onOpenedChange({ opened: true, source: "HOVER_TIMEOUT" });
            }, MenuOpenedByHover.openCloseDelayMs);
        };
        _this.hoverEnd = function () {
            _this.clearCloseDelayTimer();
            _this.timerCloseDelay = window.setTimeout(function () {
                _this.props.onOpenedChange({ opened: false, source: "HOVER_TIMEOUT" });
            }, MenuOpenedByHover.openCloseDelayMs);
        };
        return _this;
    }
    MenuOpenedByHover.prototype.componentWillUnmount = function () {
        this.clearCloseDelayTimer();
    };
    MenuOpenedByHover.prototype.render = function () {
        return (react_1.default.createElement(MenuPosition_1.MenuPosition, { toggler: react_1.default.createElement("div", { onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd }, this.props.toggler), togglerWrapperClassName: this.props.togglerWrapperClassName, opened: this.props.opened, topLevelMenu: this.props.topLevelMenu, alignment: this.props.alignment, spacing: this.props.spacing, offset: this.props.offset, portalTarget: this.props.portalTarget },
            react_1.default.createElement("div", { onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd }, this.props.children)));
    };
    MenuOpenedByHover.openCloseDelayMs = 200;
    return MenuOpenedByHover;
}(react_1.default.Component));
exports.MenuOpenedByHover = MenuOpenedByHover;
//# sourceMappingURL=MenuOpenedByHover.js.map